import messagesJa from './ja';
import { Locale, Locales } from 'types/locales';

export const defaultLocale: Locale = {
  locale: 'ja',
  messages: messagesJa,
};

export const locales: Locales = {
  // 'en-US': { locale: 'en-US', messages: messagesEnUS },
  ja: { locale: 'ja', messages: messagesJa },
};
